import { ArchetypeDefinition } from '../../archetypeTypes';

export const BELONGING_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'neighbor',
        name: 'Neighbor',
        description: 'Connectivity and mutual exchange across edges.',
        category: 'Belonging',
        tags: ['connection', 'mutuality', 'participation'],
        weights: { edgeCount: 0.35, nodeCount: 0.25, stability: 0.2, averageNodeEnergy: 0.2 }
    },
    {
        key: 'orphan',
        name: 'Orphan',
        description: 'Seeks belonging; stabilizes through many modest connections.',
        category: 'Belonging',
        tags: ['belonging', 'grounding', 'relation'],
        weights: { nodeCount: 0.35, edgeCount: 0.25, stability: 0.25, averageNodeEnergy: 0.15 }
    }
];


